'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hoursAfter.js
// module id = 681
// module chunks = 0